import BuyerPortalButton from "./BuyerPortalButton";
import WhatsAppButton from "./WhatsAppButton";

// Single fixed anchor for both floating buttons. Stacking them here (instead
// of each button carrying its own separate `fixed` position) guarantees a
// consistent gap between them — previously BuyerPortalButton was pinned at a
// hardcoded bottom-24 and WhatsAppButton's own "Need help?" tooltip could
// grow tall enough to collide with it.
const FloatingActionButtons = () => {
  return (
    <div className="fixed z-50 flex flex-col items-end gap-3 bottom-4 right-4 sm:bottom-6 sm:right-6">
      <BuyerPortalButton />
      <WhatsAppButton />
    </div>
  );
};

export default FloatingActionButtons;
